import { z } from "zod";

import { OpaqueIdSchema } from "./identity-schemas";
import { SupportTicketUpdateSchema } from "./support-schemas";

// ADR-0089: saved replies a person inserts into a reply, and changes to many tickets at once.

export const MAX_SAVED_REPLIES = 200;

export const SupportSavedReplySchema = z.strictObject({
  id: OpaqueIdSchema,
  title: z.string().min(1).max(120),
  bodyText: z.string().min(1).max(20_000),
  updatedAt: z.number().int().nonnegative(),
  updatedByName: z.string().max(160).nullable(),
});
export type SupportSavedReply = z.infer<typeof SupportSavedReplySchema>;

export const SupportSavedReplyInputSchema = z.strictObject({
  title: z.string().trim().min(1, "Give it a title.").max(120),
  bodyText: z.string().trim().min(1, "Write the reply.").max(20_000),
});
export type SupportSavedReplyInput = z.infer<typeof SupportSavedReplyInputSchema>;

export const SupportSavedReplyListSchema = z.strictObject({
  replies: z.array(SupportSavedReplySchema).max(MAX_SAVED_REPLIES),
});

export const SupportSavedReplyResultSchema = z.strictObject({ reply: SupportSavedReplySchema });

export const SupportBulkUpdateSchema = z.strictObject({
  ticketIds: z
    .array(OpaqueIdSchema)
    .min(1)
    .max(50)
    .transform((ids) => [...new Set(ids)]),
  update: SupportTicketUpdateSchema,
});
export type SupportBulkUpdate = z.infer<typeof SupportBulkUpdateSchema>;

export const SupportBulkUpdateResultSchema = z.strictObject({
  updated: z.array(z.strictObject({ ticketId: OpaqueIdSchema, changed: z.array(z.string()) })),
  refused: z.array(
    z.strictObject({
      ticketId: OpaqueIdSchema,
      reason: z.enum(["not_found", "forbidden", "invalid"]),
    }),
  ),
});
export type SupportBulkUpdateResult = z.infer<typeof SupportBulkUpdateResultSchema>;
